import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "src/app/Core/services/auth.service";
import { environment } from "src/environments/environment";

@Component({
    selector: 'login',
    templateUrl:'./login.component.html',
    styleUrls:['./login.component.css']
})



export class LoginComponent implements OnInit {
    loginForm!: FormGroup;
    redirectUrl = '';

    private readonly allowedExternalRedirectUrls = new Set<string>(environment.external_redirect_urls || []);


    
  constructor(private fb: FormBuilder,
    private auth: AuthService,
    private route: ActivatedRoute) { }

  private validateAndNormalizeRedirectUrl(rawRedirectUrl: string | null): string {
    console.log('Raw redirect URL:', rawRedirectUrl);
    const normalizedCandidate = rawRedirectUrl?.trim() ?? '';
    if (!normalizedCandidate) {
      console.log('No redirect URL provided, defaulting to empty string.');
      return '';
    }

    try {
      const parsedUrl = new URL(normalizedCandidate);
      if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
        console.log('Invalid protocol in redirect URL:', parsedUrl.protocol);
        return '';
      }

      const normalizedUrl = `${parsedUrl.origin}${parsedUrl.pathname}`;
      console.log('Normalized redirect URL:', normalizedUrl);
      let finalUrl = this.allowedExternalRedirectUrls.has(normalizedUrl) ? normalizedUrl : '';
      console.log('Final redirect URL after validation:', finalUrl);
      return finalUrl;
    } catch {
      return '';
    }
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });

    this.redirectUrl = this.validateAndNormalizeRedirectUrl(
      this.route.snapshot.queryParamMap.get('redirect_url')
    );
  }

  onSubmit(form: FormGroup) {
    if (form.valid) {
      this.auth.signIn(form.value, this.redirectUrl)
    }
  }
}